import { CurrentUser } from 'Roblox';
import catalogModule from '../catalogModule';

function catalogService(
  $log,
  $q,
  httpService,
  eventStreamService,
  catalogConstants,
  utilityService
) {
  'ngInject';

  return {
    getMetadataFromApi() {
      return httpService.httpGet(catalogConstants.endpoints.getMetadata);
    },

    getSearchOptions() {
      const urlConfig = catalogConstants.endpoints.getSearchOptionsUrl;

      return httpService.httpGet(urlConfig);
    },

    getNavigationMenuItems() {
      return httpService.httpGet(catalogConstants.endpoints.getNavigationMenuItems);
    },

    getSearchItems(params, isFullScreenEnabled) {
      const { numberOfSearchItems, numberOfSearchItemsForFullScreen } = catalogConstants;
      const urlParams = {
        limit: isFullScreenEnabled ? numberOfSearchItemsForFullScreen : numberOfSearchItems
      };
      Object.assign(urlParams, params);
      return httpService.httpGet(catalogConstants.endpoints.getSearchItems, urlParams);
    },

    getCatalogItemDetails(itemsMapKey) {
      const { endpoints, priceStatus } = catalogConstants;
      const items = [];
      for (const key in itemsMapKey) {
        if (Object.prototype.hasOwnProperty.call(itemsMapKey, key)) {
          items.push(itemsMapKey[key]);
        }
      }
      const requestData = {
        items
      };
      return httpService
        .httpPost(endpoints.getCatalogItemDetails, requestData)
        .then(function success(result) {
          const returnResult = result && result.data ? result.data : [];
          returnResult.forEach(item => {
            const { id } = item;
            item.key = itemsMapKey[id].key;
            if (item.priceStatus === priceStatus.free) {
              item.isFree = true;
            }
            utilityService.mapItemRestrictionIcons(item);
            utilityService.mapItemStatusIconsAndLabels(item);
            utilityService.buildUserLink(item);
          });
          return returnResult;
        });
    }
  };
}

catalogModule.factory('catalogService', catalogService);

export default catalogService;
